module.exports = __webpack_public_path__ + "static/media/member.19c46021.pdf";